import React from "react";
import { FaBoxOpen } from "react-icons/fa";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";

const NoProductFound = () => {
    const history = useHistory();
  return (
    <div
      style={{
        width: "100%",
        height: "100%",
        minHeight: "400px",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        background: "#fafafa",
        borderRadius: "10px",
      }}
    >
      <div
        style={{
          textAlign: "center",
          padding: "40px",
        }}
      >
        <div
          style={{
            width: "90px",
            height: "90px",
            margin: "0 auto 20px auto",
            borderRadius: "50%",
            background: "#f1f1f1",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <FaBoxOpen size={40} color="#bdbdbd" />
        </div>

        <h2
          style={{
            fontSize: "20px",
            fontWeight: "600",
            marginBottom: "8px",
            color: "#333",
          }}
        >
          No Products Found
        </h2>

        <p
          style={{
            fontSize: "14px",
            color: "#777",
            marginBottom: "20px",
          }}
        >
          We couldn't find any products matching your search.
        </p>

        <button
          style={{
            padding: "10px 22px",
            border: "none",
            borderRadius: "6px",
            background: "#B3902D",
            color: "#fff",
            fontSize: "14px",
            cursor: "pointer",
          }}
          onClick={() => {
            history.push("/");
          }}
        >
          Browse Products
        </button>
      </div>
    </div>
  );
};

export default NoProductFound;